<template>
<div class="recruitPopWrap">
	<div class="recruitPopBox">

		<div class="jobTitleWrap">
			<div class="in">
				<h4 class="title">경영지원 부문</h4>
			</div>
		</div>

		<div class="jobListWrap">
			<ul class="jobList">
				<li class="job1">
					<h5 class="jobName">경영지원</h5>
					<ul class="description">
						<li class="intro">
							<span class="tit">소개</span>
							<span>인사/노무, 총무, 회계 등 회사의 전반적인 운영을 책임집니다.</span>
						</li>
						<li class="position">
							<span class="tit">직무</span>
							<span>인사노무, 총무, 회계, 자금</span>
						</li>
						<li class="conditions">
							<span class="tit">우대조건</span>
							<ul>
								<li>관련학과, 관련업무 경험</li>
							</ul>
						</li>
					</ul>
				</li>
			</ul>
		</div>

		<div class="btnPopClose"><a href="#;" @click="$emit('close'), popClose()">닫기</a></div>
		
	</div>
</div>
</template>
<script>
export default {
	created(){
		$('body').addClass('popOpen');
	},
	methods: {
		popClose(){
			$('body').removeClass('popOpen');
		}
	}
}
</script>